export default "__VITE_ASSET__BX8phlHd__"